module.exports = {"411325100":"城关镇","411325101":"夏馆镇","411325102":"师岗镇","411325103":"马山口镇","411325104":"湍东镇","411325105":"赤眉镇","411325106":"瓦亭镇","411325107":"王店镇","411325108":"灌涨镇","411325109":"桃溪镇","411325110":"岞岖镇","411325111":"余关镇","411325300":"板场乡","411325301":"大桥乡","411325302":"赵店乡","411325306":"七里坪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411325.json
// module id = 1502
// module chunks = 0